import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { adminApi, getToken, setToken } from "../lib/api";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import "./admin.css";

export default function AdminPage() {
  const [state, setState] = useState({ checking: true, user: null });

  useEffect(() => {
    if (!getToken()) return setState({ checking: false, user: null });
    adminApi.get("/admin/me")
      .then((r) => setState({ checking: false, user: r.data.username }))
      .catch(() => { setToken(null); setState({ checking: false, user: null }); });
  }, []);

  const logout = () => { setToken(null); setState({ checking: false, user: null }); };

  if (state.checking) {
    return <div className="admin-root min-h-screen grid place-items-center"><Loader2 className="w-7 h-7 animate-spin text-[#ee3a70]" /></div>;
  }
  return (
    <div className="admin-root min-h-screen">
      {state.user
        ? <AdminDashboard user={state.user} onLogout={logout} />
        : <AdminLogin onLogin={(u) => setState({ checking: false, user: u })} />}
    </div>
  );
}
